// "22 Oct 2026, 3:05 PM" in Malaysia time — when a memo went out or was read.
const STAMP = new Intl.DateTimeFormat('en-MY', {
  timeZone: 'Asia/Kuala_Lumpur', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit',
});

export const memoDate = (v) => (v ? STAMP.format(new Date(v)).replace(/\b(am|pm)\b/g, (m) => m.toUpperCase()) : '');
